import React, { useState, useEffect } from "react"
import { Button, Card, Checkbox, Collapse, message } from "antd"
import { useLocation, useNavigate } from "react-router-dom"
import apiClient from "../../Utils/apiClient"
import PanelLayout from "../../Layout/PanelLayout"
import MENU from "../../Layout/MenuJson"
import ExtraMenu from "../../Layout/ExtraMenu"

const { Panel } = Collapse

const ManageRolePermissions = () => {
  const navigate = useNavigate()
  const { state } = useLocation()

  const roleName = state?.name
  const role = state?._id
  const [selectedPermissions, setSelectedPermissions] = useState([])

  useEffect(() => {
    fetchRolePermissions()
  }, [role])

  const fetchRolePermissions = async () => {
    try {
      const res = await apiClient(`/roles/${role}/permissions`, "GET")
      if (res.success && Array.isArray(res.data)) {
        setSelectedPermissions(res.data)
      } else {
        setSelectedPermissions([])
      }
    } catch (err) {
      console.error("Error fetching permissions:", err)
      setSelectedPermissions([])
    }
  }

  const handlePermissionChange = (value, checked) => {
    setSelectedPermissions((prev) => {
      const newPerms = new Set(prev)
      if (checked) newPerms.add(value)
      else newPerms.delete(value)
      return Array.from(newPerms)
    })
  }

  const handleSave = async () => {
    try {
      const res = await apiClient(`/roles/${role}/permissions`, "POST", {
        permissions: selectedPermissions,
      })
      if (res.success) {
        message.success("Permissions updated successfully")
        navigate("/roles")
      } else {
        message.info(res.message || "Failed to update permissions")
      }
    } catch (err) {
      message.error("Error saving permissions")
    }
  }

  const renderPermissionCheckboxes = (accessArray) => {
    if (!accessArray || accessArray.length === 0) return null

    return accessArray.map((perm) => (
      <Checkbox
        key={perm.value}
        checked={selectedPermissions.includes(perm.value)}
        onChange={(e) => handlePermissionChange(perm.value, e.target.checked)}
        style={{ marginRight: 16 }}
      >
        {perm.label}
      </Checkbox>
    ))
  }

  const renderPermissionPanelContent = (menuItem) => {
    if (menuItem.children) {
      return menuItem.children.map((child, index) => (
        <div
          key={child.title}
          style={{
            borderBottom:
              index === menuItem.children.length - 1
                ? "none"
                : "1px solid #f0f0f0",
            padding: "8px 0",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
        >
          <strong style={{ flex: "0 0 30%" }}>{child.title}</strong>
          <div style={{ flex: 1 }}>
            {child.Link
              ? renderPermissionCheckboxes(child.access)
              : renderPermissionPanelContent(child)}
          </div>
        </div>
      ))
    }

    if (menuItem.Link) {
      return (
        <div
          key={menuItem.title}
          style={{
            padding: "8px 0",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
        >
          <strong style={{ flex: "0 0 30%" }}>{menuItem.title}</strong>
          <div style={{ flex: 1 }}>
            {renderPermissionCheckboxes(menuItem.access)}
          </div>
        </div>
      )
    }

    return null
  }

  const Data = [...MENU, ...ExtraMenu]

  const filteredMenu = Data.map((group) => {
    if (Array.isArray(group.children) && group.children.length > 0) {
      const filteredChildren = group.children.filter(
        (child) =>
          !child.dontShowFor?.includes(roleName?.toLowerCase()) &&
          !child.notInMenu?.includes(roleName?.toLowerCase())
      )
      return { ...group, children: filteredChildren }
    }

    const shouldHide =
      group.dontShowFor?.includes(roleName?.toLowerCase()) ||
      group.notInMenu?.includes(roleName?.toLowerCase())

    return shouldHide ? null : group
  })
    .filter(Boolean)
    .filter((group) => {
      return !group.children || group.children.length > 0
    })

  return (
    <PanelLayout
      title={`Manage Roles: ${roleName}`}
      subtitle="Toggle console permissions for this role."
    >
      <Collapse accordion bordered={false}>
        {filteredMenu.map((menuItem) => (
          <Panel
            key={menuItem.title}
            header={<b>{menuItem.title}</b>}
            style={{
              backgroundColor: "#fff",
              borderRadius: 8,
              marginBottom: 10,
              overflow: "hidden",
            }}
            bodyStyle={{ backgroundColor: "#fff" }}
          >
            <Card size="small" style={{ backgroundColor: "#fff" }}>
              {renderPermissionPanelContent(menuItem)}
            </Card>
          </Panel>
        ))}
      </Collapse>

      <div className="mt-2">
        <Button className="me-2" onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </div>
    </PanelLayout>
  )
}

export default ManageRolePermissions
